import React from 'react';
import { Checkbox, Tooltip, Typography, WithInfoIcon } from 'seagull';
import ConditionalWrapper from "../ConditionalWrapper/ConditionalWrapper";
export function AllowManualPaymentsCheckbox(props) {
  const {
    value,
    isSampleRelationship = false,
    onChange
  } = props;
  return /*#__PURE__*/React.createElement(WithInfoIcon, {
    info: "Select if your client prefers to manually approve each payment, rather than have payments processed automatically."
  }, /*#__PURE__*/React.createElement(ConditionalWrapper, {
    condition: isSampleRelationship,
    wrapper: children => /*#__PURE__*/React.createElement(Tooltip, {
      placement: "top",
      title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
        skin: "invertedStandard",
        weight: "bold"
      }, "Testing Mode Disables Payments"), /*#__PURE__*/React.createElement(Typography, {
        skin: "invertedStandard"
      }, "When creating a proposal with a sample client, this option is disabled. No payment will be processed or saved when you send it, so you can interact with it freely."))
    }, /*#__PURE__*/React.createElement("div", null, children))
  }, /*#__PURE__*/React.createElement(Checkbox, {
    "data-testid": "agreement-studio-allow-manual-payments-Checkbox",
    checked: value && !isSampleRelationship,
    disabled: isSampleRelationship,
    onChange: function (_onChange) {
      function onChange() {
        return _onChange.apply(this, arguments);
      }
      onChange.toString = function () {
        return _onChange.toString();
      };
      return onChange;
    }(() => onChange(!value))
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: isSampleRelationship ? 'disabled' : 'standard'
  }, "Let my client manually approve each payment"))));
}